module.exports = __webpack_public_path__ + "static/media/tic-tac-toe3.421bd4c5.png";